import useDebounce from '@UI/Hooks/useDebounce';
import beneficiaryFiltersSignal, {
	setBeneficiaryFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/Signals/beneficiaryFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { InputText } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

/**
 * Keeps local state for immediate keystroke feedback while the write to `beneficiaryFiltersSignal` is
 * debounced. The local state is resynchronised from the signal whenever it changes for another reason
 * (typically a filter reset), so the field never shows stale text.
 */
const SearchFilter: React.FC = () => {
	const currentFilters = useSignalValue(beneficiaryFiltersSignal);
	const [searchInput, setSearchInput] = React.useState(currentFilters.search);
	const debouncedSearch = useDebounce(searchInput, SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setSearchInput(currentFilters.search);
	}, [currentFilters.search]);

	React.useEffect(() => {
		if (debouncedSearch === beneficiaryFiltersSignal.peek().search) {
			return;
		}

		setBeneficiaryFilters(beneficiaryFiltersSignal.peek().setSearch(debouncedSearch));
	}, [debouncedSearch]);

	const handleSearchChange = React.useCallback((value: string) => {
		setSearchInput(value);
	}, []);

	return (
		<InputText
			name="beneficiarySearch"
			label="Recherche"
			isLabelHidden
			placeholder="Nom, prénom ou nom de naissance"
			value={searchInput}
			onChange={handleSearchChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default SearchFilter;
